import {BranchType, Status} from "../enums/enums";

const zipCodePattern = /^[0-9]{6}$/;
const latitudePattern = /^[-]?(([0-8]?[0-9])\.(\d+))|(90(\.0+)?)$/;
const longitudePattern = /^[-]?((1[0-7][0-9])\.(\d+))|([0-9]?[0-9]\.(\d+))|(180(\.0+)?)$/;

export const branchSchema = ({list}) => {
    const {
        items: restaurantList,
        status: restaurantListStatus,
    } = list.restaurant;

    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 4},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            branchType: {
                type: 'select',
                label: 'Branch Type',
                options: BranchType,
                enums: true,
                columns: {md: 12, lg: 4},
                validation: (value) => {
                    if (value.trim() === '') return 'Branch type is required';
                    return null;
                },
            },
            restaurant: {
                type: 'select',
                label: 'Restaurant',
                columns: {md: 12, lg: 4},
                options: restaurantListStatus === "success" ? restaurantList : {},
                validation: (value) => {
                    if (value === '') {
                        return 'Restaurant is required';
                    }
                    return null;
                }
            },

            address: {
                type: 'object',
                label: 'Address',
                properties: {
                    street: {
                        type: 'text',
                        label: 'Street, Building, Apartment',
                        columns: {md: 12, lg: 9},
                        validation: (value) => {
                            if (value.trim() === '') return 'Street/ Building/ Apartment is required';
                            return null;
                        },
                    },
                    zipCode: {
                        type: 'text',
                        label: 'Zip Code',
                        columns: {md: 12, lg: 3},
                        validation: (value) => {
                            if (value.trim() === '') return 'Zip Code is required';
                            if (!zipCodePattern.test(value)) return 'Invalid Zip Code';
                            return null;
                        }
                    },
                    city: {
                        type: 'text',
                        label: 'City',
                        columns: {md: 12, lg: 4},
                        validation: (value) => {
                            if (value.trim() === '') return 'City is required';
                            return null;
                        },
                    },
                    state: {
                        type: 'text',
                        label: 'State',
                        columns: {md: 12, lg: 4},
                        validation: (value) => {
                            if (value.trim() === '') return 'State is required';
                            return null;
                        },
                    },
                    country: {
                        type: 'text',
                        label: 'Country',
                        columns: {md: 12, lg: 4},
                        validation: (value) => {
                            if (value.trim() === '') return 'Country is required';
                            return null;
                        },
                    }
                }
            },
            location: {
                type: 'object',
                label: 'Location',
                properties: {
                    coordinates: {
                        type: 'object',
                        label: 'Coordinates',
                        properties: {
                            latitude: {
                                type: 'text',
                                columns: {md: 12, lg: 6},
                                placeholder: 'Latitude',
                                validation: (value) => {
                                    if (value.toString().trim() === '') return 'Latitude is required';
                                    if (!latitudePattern.test(value)) return 'Invalid Latitude';
                                    return null;
                                }
                            },
                            longitude: {
                                type: 'text',
                                columns: {md: 12, lg: 6},
                                placeholder: 'Longitude',
                                validation: (value) => {
                                    if (value.toString().trim() === '') return 'Longitude is required';
                                    if (!longitudePattern.test(value)) return 'Invalid Longitude';
                                    return null;
                                }
                            }
                        }
                    },
                }
            },
            googlePlaceId: {
                type: 'text',
                label: 'Google Place Id',
                columns: {md: 12, lg: 6},
            },
            googleReviewLink: {
                type: 'text',
                label: 'Google Review Link',
                columns: {md: 12, lg: 6},
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {md: 12, lg: 4},
                validation: (value) => {
                    if (value === '') return 'Status is required';
                    return null;
                },
            },
        }
    )
}

